import { useLazyRef } from './useLazyRef';

/**
 * Hold constant value for the full lifetime of the component.
 * The value is lazily initialized at mount.
 *
 * @param {function} fn - initializer function
 * @return {*}
 */
export const useLazyConst = (fn) => useLazyRef(fn).current;
